
import React, { useState } from 'react';
import { ProfileView } from '@/components/profile/ProfileView';
import { ProfileEdit } from '@/components/profile/ProfileEdit';
import { Header } from '@/components/layout/Header';
import { PageWrapper } from '@/components/layout/PageWrapper';

interface ProfileProps {
  onNavigateToHome: () => void;
}

const Profile = ({ onNavigateToHome }: ProfileProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSaved = () => {
    setIsEditing(false);
  };

  return (
    <PageWrapper layout="no-sidebar">
      <div className="min-h-screen bg-gray-50 font-sans">
      <Header 
        onNavigateToProfile={() => {}} 
        onNavigateToHome={onNavigateToHome}
      />
      <main className="max-w-2xl mx-auto py-8 px-4 sm:px-6 lg:px-8 font-sans">
        {isEditing ? (
          <ProfileEdit onCancel={handleCancel} onSaved={handleSaved} />
        ) : (
          <ProfileView onEdit={handleEdit} />
        )}
      </main>
    </div>
    </PageWrapper>
  );
};

export default Profile;
